import s from './HtmlToComponent.scss'

const HtmlToComponent = ({ html, icons }) => {
  // const htmlDecode = input => {
  //   var e = document.createElement('div')
  //   e.innerHTML = input
  //   return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
  // }

  return (
    <>
      {icons}
      <div className={s.wrapper} dangerouslySetInnerHTML={{ __html: html }} />
    </>
  )
}

export default HtmlToComponent
